import React from 'react';

export const JiraProductIllustration = () => {
  return (
    <svg
      width="630"
      height="459"
      viewBox="0 0 630 459"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true">
      <g clipPath="url(#clip0_3169_126761)">
        <path
          d="M498.916 87.4014H628.916L621.416 407.401H498.916V87.4014Z"
          fill="url(#paint0_linear_3169_126761)"
        />
        <path
          d="M112.916 1.40137L563.916 13.791V435.038L112.916 450.401V1.40137Z"
          fill="url(#paint1_linear_3169_126761)"
        />
        <path
          d="M108.916 2.40137L563.916 14.8462V437.97L108.916 453.401V2.40137Z"
          fill="url(#paint2_linear_3169_126761)"
        />
        <path
          d="M6.91602 141.401H153.485C155.722 158.363 155.367 176.361 174.213 223.827C191.973 268.555 207.617 294.057 219.916 313.401H51.3609C47.4475 308.215 36.6018 288.926 24.5263 253.264C12.4507 217.603 7.7546 163.83 6.91602 141.401Z"
          fill="url(#paint3_linear_3169_126761)"
        />
        <g opacity="0.5">
          <path
            d="M177.744 49.5518L134.081 27.2472C95.9919 7.78994 49.3385 22.898 29.879 60.9915C10.4195 99.085 25.5222 145.74 63.6114 165.197L107.274 187.502"
            stroke="url(#paint4_linear_3169_126761)"
            strokeWidth="1.40594"
            strokeMiterlimit="10"
          />
          <path
            d="M171.467 62.8586L125.629 39.4431C95.0522 23.8235 57.6078 35.8852 41.9693 66.4988C26.3308 97.1125 38.4854 134.558 69.0621 150.177L114.9 173.593"
            stroke="url(#paint5_linear_3169_126761)"
            strokeWidth="1.40594"
            strokeMiterlimit="10"
          />
          <path
            d="M99.1634 202.121L56.818 180.49C10.5277 156.843 -7.82952 100.145 15.836 53.8178C39.5015 7.49057 96.1807 -10.8297 142.471 12.817L184.816 34.4485"
            stroke="url(#paint6_linear_3169_126761)"
            strokeWidth="1.40594"
            strokeMiterlimit="10"
          />
        </g>
        <g>
          <rect
            x="15.0039"
            y="67.3491"
            width="23.8348"
            height="10.7641"
            transform="rotate(100.932 15.0039 67.3491)"
            fill="url(#paint7_linear_3169_126761)"
          />
        </g>
        <path
          d="M14.9309 67.7268C14.3672 70.6453 11.5444 72.5542 8.6259 71.9905C5.70741 71.4269 3.79847 68.604 4.36216 65.6855C4.92585 62.767 7.74871 60.8581 10.6672 61.4218C13.5857 61.9855 15.4946 64.8083 14.9309 67.7268Z"
          fill="url(#paint8_linear_3169_126761)"
        />
        <path
          d="M14.9309 67.7268C14.3672 70.6453 11.5444 72.5542 8.6259 71.9905C5.70741 71.4269 3.79847 68.604 4.36216 65.6855C4.92585 62.767 7.74871 60.8581 10.6672 61.4218C13.5857 61.9855 15.4946 64.8083 14.9309 67.7268Z"
          fill="url(#paint9_linear_3169_126761)"
        />
        <path
          d="M594.217 403.601L564.544 435.747C538.321 464.154 494.035 465.925 465.628 439.703L435.917 412.277"
          stroke="url(#paint10_linear_3169_126761)"
          strokeWidth="1.4"
        />
        <path
          d="M585.898 391.924L550.525 430.245C531.794 450.536 500.161 451.801 479.871 433.071L443.984 399.944"
          stroke="url(#paint11_linear_3169_126761)"
          strokeWidth="1.4"
        />
        <path
          d="M578.189 383.808L543.523 421.362C528.539 437.595 503.233 438.607 487 423.623L451.474 390.829"
          stroke="url(#paint12_linear_3169_126761)"
          strokeWidth="1.4"
        />
        <path
          d="M570.076 375.317L535.136 413.168C524.647 424.531 506.932 425.24 495.57 414.751L459.341 381.309"
          stroke="url(#paint13_linear_3169_126761)"
          strokeWidth="1.4"
        />
        <g filter="url(#filter0_d_3169_126761)">
          <rect
            x="37.5"
            y="33.5"
            width="562"
            height="390"
            rx="8.5"
            stroke="black"
            strokeOpacity="0.1"
            shapeRendering="crispEdges"
          />
          <mask id="path-16-inside-1_3169_126761" fill="white">
            <path d="M38 42C38 37.5817 41.5817 34 46 34H591C595.418 34 599 37.5817 599 42V73.4924H38V42Z" />
          </mask>
          <path
            d="M38 42C38 37.5817 41.5817 34 46 34H591C595.418 34 599 37.5817 599 42V73.4924H38V42Z"
            fill="white"
          />
          <path
            d="M38 34H599H38ZM599 74.3257H38V72.6591H599V74.3257ZM38 73.4924V34V73.4924ZM599 34V73.4924V34Z"
            fill="#091E42"
            fillOpacity="0.14"
            mask="url(#path-16-inside-1_3169_126761)"
          />
          <g clipPath="url(#clip1_3169_126761)">
            <path
              d="M75.3245 48.2044H77.0713V56.9527C77.0713 59.2594 76.0321 60.8698 73.622 60.8698C72.7155 60.8698 72.0079 60.7175 71.5215 60.5434V58.8677C72.0521 59.0853 72.6934 59.1941 73.3346 59.1941C74.816 59.1941 75.3245 58.3237 75.3245 57.0615V48.2044Z"
              fill="#44546F"
            />
            <path
              d="M80.2774 47.5298C80.9629 47.5298 81.4493 47.9433 81.4493 48.6832C81.4493 49.4013 80.9629 49.8365 80.2774 49.8365C79.592 49.8365 79.1056 49.4231 79.1056 48.6832C79.1056 47.965 79.592 47.5298 80.2774 47.5298ZM79.4151 51.2075H81.0956V60.7827H79.4151V51.2075Z"
              fill="#44546F"
            />
            <path
              d="M85.2522 60.7827H83.616V51.2075H85.2522V52.8832C85.8271 51.7516 86.8 50.9464 88.7015 51.0552V52.6656C86.5568 52.448 85.2522 53.079 85.2522 55.1247V60.7827Z"
              fill="#44546F"
            />
            <path
              d="M96.5509 59.0636C95.9318 60.3257 94.7599 60.9786 93.2564 60.9786C90.6694 60.9786 89.3649 58.8242 89.3649 55.9951C89.3649 53.2967 90.7357 51.0117 93.4554 51.0117C94.8705 51.0117 95.976 51.6428 96.5509 52.8832V51.2075H98.2313V60.7827H96.5509V59.0636ZM93.6986 59.4553C95.2021 59.4553 96.5288 58.5195 96.5288 56.3869V55.6252C96.5288 53.4925 95.3127 52.5568 93.8755 52.5568C91.9961 52.5568 91.0232 53.7754 91.0232 55.9951C91.0453 58.3019 91.9739 59.4553 93.6986 59.4553Z"
              fill="#44546F"
            />
            <path
              d="M66.5468 46.2461H58.8965C58.8965 48.1176 60.4442 49.6409 62.3458 49.6409H63.7609V50.9684C63.7609 52.8399 65.3086 54.3633 67.2102 54.3633V46.8989C67.2102 46.529 66.9227 46.2461 66.5468 46.2461Z"
              fill="#2684FF"
            />
            <path
              d="M62.7656 49.989H55.1152C55.1152 51.8605 56.663 53.3839 58.5645 53.3839H59.9796V54.7331C59.9796 56.6046 61.5274 58.1279 63.4289 58.1279V50.6419C63.4289 50.2937 63.1415 49.989 62.7656 49.989Z"
              fill="url(#paint14_linear_3169_126761)"
            />
            <path
              d="M58.9843 53.7539H51.334C51.334 55.6254 52.8817 57.1488 54.7833 57.1488H56.1984V58.4762C56.1984 60.3477 57.7461 61.8711 59.6477 61.8711V54.4068C59.6477 54.0368 59.3381 53.7539 58.9843 53.7539Z"
              fill="url(#paint15_linear_3169_126761)"
            />
          </g>
          <g clipPath="url(#clip2_3169_126761)">
            <mask id="path-22-inside-2_3169_126761" fill="white">
              <path d="M38 73.4924H198.004V423H46C41.5817 423 38 419.418 38 415V73.4924Z" />
            </mask>
            <path
              d="M38 73.4924H198.004V423H46C41.5817 423 38 419.418 38 415V73.4924Z"
              fill="#F9F9F9"
            />
            <rect x="58" y="86.4924" width="20" height="20" rx="2.5" fill="#DCDFE4" />
            <rect
              width="88"
              height="6"
              rx="3"
              transform="matrix(1 0 0 -1 87.2285 100.534)"
              fill="#DCDFE4"
            />
            <g clipPath="url(#clip3_3169_126761)">
              <rect x="57.2285" y="129.534" width="50" height="6" rx="3" fill="#DCDFE4" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M62.666 147.159H70.9993C71.6624 147.159 72.2983 147.423 72.7671 147.891C73.236 148.36 73.4993 148.996 73.4993 149.659C73.4993 150.322 73.236 150.958 72.7671 151.427C72.2983 151.896 71.6624 152.159 70.9993 152.159H62.666C62.003 152.159 61.3671 151.896 60.8982 151.427C60.4294 150.958 60.166 150.322 60.166 149.659C60.166 148.996 60.4294 148.36 60.8982 147.891C61.3671 147.423 62.003 147.159 62.666 147.159V147.159ZM62.666 148.826C62.445 148.826 62.233 148.914 62.0768 149.07C61.9205 149.226 61.8327 149.438 61.8327 149.659C61.8327 149.88 61.9205 150.092 62.0768 150.248C62.233 150.405 62.445 150.493 62.666 150.493H70.9993C71.2204 150.493 71.4323 150.405 71.5886 150.248C71.7449 150.092 71.8327 149.88 71.8327 149.659C71.8327 149.438 71.7449 149.226 71.5886 149.07C71.4323 148.914 71.2204 148.826 70.9993 148.826H62.666ZM65.9993 152.993H72.666C73.3291 152.993 73.9649 153.256 74.4338 153.725C74.9026 154.194 75.166 154.829 75.166 155.493C75.166 156.156 74.9026 156.791 74.4338 157.26C73.9649 157.729 73.3291 157.993 72.666 157.993H65.9993C65.3363 157.993 64.7004 157.729 64.2316 157.26C63.7627 156.791 63.4993 156.156 63.4993 155.493C63.4993 154.829 63.7627 154.194 64.2316 153.725C64.7004 153.256 65.3363 152.993 65.9993 152.993V152.993ZM65.9993 154.659C65.7783 154.659 65.5664 154.747 65.4101 154.903C65.2538 155.06 65.166 155.271 65.166 155.493C65.166 155.714 65.2538 155.925 65.4101 156.082C65.5664 156.238 65.7783 156.326 65.9993 156.326H72.666C72.887 156.326 73.099 156.238 73.2553 156.082C73.4116 155.925 73.4993 155.714 73.4993 155.493C73.4993 155.271 73.4116 155.06 73.2553 154.903C73.099 154.747 72.887 154.659 72.666 154.659H65.9993ZM62.666 158.826H67.666C68.3291 158.826 68.9649 159.089 69.4338 159.558C69.9026 160.027 70.166 160.663 70.166 161.326C70.166 161.989 69.9026 162.625 69.4338 163.094C68.9649 163.562 68.3291 163.826 67.666 163.826H62.666C62.003 163.826 61.3671 163.562 60.8982 163.094C60.4294 162.625 60.166 161.989 60.166 161.326C60.166 160.663 60.4294 160.027 60.8982 159.558C61.3671 159.089 62.003 158.826 62.666 158.826V158.826ZM62.666 160.493C62.445 160.493 62.233 160.58 62.0768 160.737C61.9205 160.893 61.8327 161.105 61.8327 161.326C61.8327 161.547 61.9205 161.759 62.0768 161.915C62.233 162.071 62.445 162.159 62.666 162.159H67.666C67.887 162.159 68.099 162.071 68.2553 161.915C68.4116 161.759 68.4993 161.547 68.4993 161.326C68.4993 161.105 68.4116 160.893 68.2553 160.737C68.099 160.58 67.887 160.493 67.666 160.493H62.666Z"
                fill="#44546F"
              />
              <rect x="86" y="152.492" width="90" height="6" rx="3" fill="#DCDFE4" />
              <path
                d="M61.8327 193.327C61.8327 193.326 71.8327 193.326 71.8327 193.326V191.657C71.8327 191.659 61.8327 191.659 61.8327 191.659V193.327ZM60.166 191.657C60.166 190.737 60.9118 189.992 61.8277 189.992H71.8377C72.7552 189.992 73.4993 190.741 73.4993 191.657V193.327C73.4996 193.769 73.3247 194.192 73.0131 194.504C72.7015 194.816 72.2788 194.992 71.8377 194.992H61.8277C61.3867 194.992 60.964 194.816 60.6525 194.504C60.341 194.191 60.166 193.768 60.166 193.327V191.657Z"
                fill="#44546F"
              />
              <path
                d="M61.8327 189.992H71.8327V188.326H61.8327V189.992ZM60.166 186.659H73.4993V191.659H60.166V186.659Z"
                fill="#44546F"
              />
              <path
                d="M63.4993 186.661C63.4993 186.659 73.4993 186.659 73.4993 186.659V184.991C73.4993 184.992 63.4993 184.992 63.4993 184.992V186.661ZM61.8327 184.991C61.8327 184.071 62.5785 183.326 63.4943 183.326H73.5043C74.4218 183.326 75.166 184.074 75.166 184.991V186.661C75.1662 187.102 74.9913 187.525 74.6798 187.837C74.3682 188.149 73.9454 188.325 73.5043 188.326H63.4943C63.0533 188.325 62.6307 188.149 62.3192 187.837C62.0076 187.525 61.8327 187.102 61.8327 186.661V184.991Z"
                fill="#44546F"
              />
              <path
                d="M61.8327 181.659V183.326H71.8327V181.659H61.8327ZM60.166 181.657C60.166 180.737 60.9118 179.992 61.8277 179.992H71.8377C72.7552 179.992 73.4993 180.741 73.4993 181.657V184.992H60.166V181.657Z"
                fill="#44546F"
              />
              <rect x="86" y="184.159" width="90" height="6" rx="3" fill="#DCDFE4" />
              <g clipPath="url(#clip4_3169_126761)">
                <rect x="44.666" y="203.492" width="146.67" height="32" rx="4" fill="#E9F2FF" />
                <path
                  d="M44.666 212.826H46.3327C47.2532 212.826 47.9993 213.572 47.9993 214.492V224.492C47.9993 225.413 47.2532 226.159 46.3327 226.159H44.666V212.826Z"
                  fill="#85B8FF"
                />
                <path
                  d="M61.3327 224.492H74.6727C74.666 224.492 74.666 214.492 74.666 214.492H61.326C61.3327 214.492 61.3327 224.492 61.3327 224.492ZM59.666 214.487C59.666 213.57 60.4143 212.826 61.3243 212.826H74.6743C75.5893 212.826 76.3327 213.572 76.3327 214.487V224.497C76.332 224.937 76.1572 225.359 75.8464 225.67C75.5357 225.982 75.1143 226.157 74.6743 226.159H61.3243C60.8842 226.158 60.4624 225.983 60.1515 225.671C59.8406 225.36 59.666 224.937 59.666 224.497V214.487Z"
                  fill="#0C66E4"
                />
                <path
                  d="M64.666 214.492V224.492H66.3327V214.492H64.666ZM69.666 214.492V224.492H71.3327V214.492H69.666Z"
                  fill="#0C66E4"
                />
                <rect x="86" y="216.826" width="90" height="6" rx="3" fill="#85B8FF" />
              </g>
              <path
                d="M75.1654 255.659H61.8279C61.372 255.659 60.9987 255.283 60.9987 254.818V246.493C60.9987 246.271 60.9109 246.06 60.7546 245.903C60.5983 245.747 60.3864 245.659 60.1654 245.659C59.9444 245.659 59.7324 245.747 59.5761 245.903C59.4198 246.06 59.332 246.271 59.332 246.493V254.818C59.3309 255.482 59.5932 256.118 60.0611 256.589C60.5291 257.059 61.1645 257.324 61.8279 257.326H75.1654C75.3864 257.326 75.5983 257.238 75.7546 257.082C75.9109 256.925 75.9987 256.714 75.9987 256.493C75.9987 256.271 75.9109 256.06 75.7546 255.903C75.5983 255.747 75.3864 255.659 75.1654 255.659ZM72.6654 248.993V251.493C72.6654 251.714 72.7532 251.925 72.9094 252.082C73.0657 252.238 73.2777 252.326 73.4987 252.326C73.7197 252.326 73.9317 252.238 74.088 252.082C74.2442 251.925 74.332 251.714 74.332 251.493V248.159C74.332 247.938 74.2442 247.726 74.088 247.57C73.9317 247.414 73.7197 247.326 73.4987 247.326H70.1654C69.9444 247.326 69.7324 247.414 69.5761 247.57C69.4198 247.726 69.332 247.938 69.332 248.159C69.332 248.38 69.4198 248.592 69.5761 248.748C69.7324 248.905 69.9444 248.993 70.1654 248.993H72.6654Z"
                fill="#44546F"
              />
              <path
                d="M68.7429 252.915C68.8991 253.071 69.1111 253.159 69.332 253.159C69.553 253.159 69.7649 253.071 69.9212 252.915L73.2545 249.582C73.3341 249.505 73.3976 249.413 73.4413 249.311C73.485 249.21 73.5079 249.1 73.5089 248.99C73.5099 248.879 73.4888 248.769 73.4469 248.667C73.405 248.564 73.3431 248.471 73.2649 248.393C73.1866 248.315 73.0936 248.253 72.9912 248.211C72.8887 248.169 72.779 248.148 72.6684 248.149C72.5577 248.15 72.4484 248.173 72.3467 248.217C72.245 248.26 72.1531 248.324 72.0762 248.403L69.332 251.148L67.4212 249.237C67.2649 249.08 67.053 248.993 66.832 248.993C66.6111 248.993 66.3991 249.08 66.2429 249.237L62.9095 252.57C62.7577 252.727 62.6737 252.938 62.6756 253.156C62.6775 253.375 62.7652 253.584 62.9197 253.738C63.0742 253.893 63.2832 253.98 63.5017 253.982C63.7202 253.984 63.9307 253.9 64.0879 253.748L66.832 251.004L68.7429 252.915Z"
                fill="#44546F"
              />
              <rect x="86" y="248.492" width="90" height="6" rx="3" fill="#DCDFE4" />
              <path
                d="M61.8327 284.318C61.8327 284.324 73.5035 284.326 73.5035 284.326C73.4985 284.326 73.4994 277.667 73.4994 277.667C73.4994 277.661 61.8285 277.659 61.8285 277.659C61.8335 277.659 61.8327 284.318 61.8327 284.318ZM60.166 277.667C60.166 276.742 60.9102 275.992 61.8285 275.992H73.5035C74.4219 275.992 75.166 276.744 75.166 277.667V284.318C75.166 285.243 74.4219 285.992 73.5035 285.992H61.8285C61.3862 285.99 60.9627 285.813 60.651 285.499C60.3393 285.185 60.1649 284.761 60.166 284.318V277.667ZM73.4994 289.326C73.4952 290.247 72.7494 290.992 71.8277 290.992H63.5044C63.0621 290.992 62.638 290.816 62.3248 290.504C62.0116 290.192 61.8347 289.768 61.8327 289.326H73.4994ZM74.3327 286.826C74.3322 287.267 74.1572 287.69 73.8458 288.002C73.5344 288.314 73.112 288.491 72.671 288.492H62.661C62.2201 288.49 61.7978 288.314 61.4865 288.002C61.1751 287.69 61 287.267 60.9994 286.826H74.3327Z"
                fill="#44546F"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M66.561 282.935C66.861 283.235 67.3452 283.235 67.6444 282.935L69.9427 280.632C70.0747 280.486 70.1454 280.295 70.1404 280.099C70.1353 279.902 70.0548 279.715 69.9155 279.576C69.7761 279.437 69.5887 279.356 69.3919 279.352C69.1952 279.347 69.0042 279.418 68.8585 279.551L67.1019 281.309L66.4727 280.681C66.3271 280.547 66.1354 280.474 65.9375 280.478C65.7396 280.482 65.5509 280.562 65.411 280.702C65.271 280.842 65.1906 281.031 65.1866 281.229C65.1825 281.427 65.2552 281.619 65.3894 281.764L66.561 282.935Z"
                fill="#44546F"
              />
              <rect x="86" y="280.159" width="90" height="6" rx="3" fill="#DCDFE4" />
            </g>
          </g>
          <path
            d="M38 73.4924H198.004H38ZM198.004 423H38H198.004ZM38 423V73.4924V423ZM198.837 73.4924V423H197.17V73.4924H198.837Z"
            fill="#091E42"
            fillOpacity="0.14"
            mask="url(#path-22-inside-2_3169_126761)"
          />
          <g clipPath="url(#clip5_3169_126761)">
            <path
              d="M198.004 73.4924H599V415C599 419.418 595.419 423 591 423H198.004V73.4924Z"
              fill="#F9F9F9"
            />
            <g clipPath="url(#clip6_3169_126761)">
              <rect x="213.232" y="118.535" width="211" height="677" rx="6.66667" fill="#F1F2F4" />
              <rect x="227.566" y="135.535" width="50" height="6" rx="3" fill="#DCDFE4" />
              <g filter="url(#filter1_d_3169_126761)">
                <rect
                  x="218.232"
                  y="158.535"
                  width="201"
                  height="106.333"
                  rx="3.33333"
                  fill="white"
                />
                <rect x="228.68" y="176.445" width="174.025" height="6" rx="3" fill="#DCDFE4" />
                <rect x="228.678" y="190.305" width="81.2118" height="6" rx="3" fill="#DCDFE4" />
                <rect x="228.232" y="208.201" width="44.6667" height="14" rx="2.5" fill="#85B8FF" />
                <g clipPath="url(#clip7_3169_126761)">
                  <g clipPath="url(#clip8_3169_126761)">
                    <path
                      d="M239.661 235.201H230.137C229.085 235.201 228.232 236.054 228.232 237.106V246.63C228.232 247.682 229.085 248.535 230.137 248.535H239.661C240.713 248.535 241.566 247.682 241.566 246.63V237.106C241.566 236.054 240.713 235.201 239.661 235.201Z"
                      fill="#63BA3C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M236.803 238.058H232.993C232.468 238.058 232.041 238.485 232.041 239.011V245.201C232.041 245.464 232.254 245.677 232.517 245.677C232.684 245.677 232.823 245.587 232.908 245.457L232.911 245.458L234.746 243.335C234.822 243.234 234.974 243.234 235.051 243.335L236.885 245.458L236.889 245.457C236.973 245.587 237.112 245.677 237.279 245.677C237.542 245.677 237.755 245.464 237.755 245.201V239.011C237.755 238.485 237.329 238.058 236.803 238.058Z"
                      fill="white"
                    />
                  </g>
                  <rect x="247.566" y="238.868" width="40.3563" height="6" rx="3" fill="#DCDFE4" />
                </g>
                <circle cx="398.922" cy="241.868" r="10" fill="#F1F2F4" />
              </g>
              <g filter="url(#filter2_d_3169_126761)">
                <rect
                  x="218.232"
                  y="270.868"
                  width="201"
                  height="101.333"
                  rx="3.33333"
                  fill="white"
                />
                <rect x="228.682" y="288.868" width="175.008" height="6" rx="3" fill="#DCDFE4" />
                <rect x="228.682" y="302.868" width="61.0286" height="6" rx="3" fill="#DCDFE4" />
                <rect x="228.232" y="321.535" width="60.6667" height="14" rx="2" fill="#4BCE97" />
                <circle cx="396.232" cy="352.201" r="10" fill="#F1F2F4" />
                <g clipPath="url(#clip9_3169_126761)">
                  <g clipPath="url(#clip10_3169_126761)">
                    <path
                      d="M239.661 345.105H230.137C229.085 345.105 228.232 345.958 228.232 347.01V356.534C228.232 357.586 229.085 358.439 230.137 358.439H239.661C240.713 358.439 241.566 357.586 241.566 356.534V347.01C241.566 345.958 240.713 345.105 239.661 345.105Z"
                      fill="#63BA3C"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M236.803 347.962H232.993C232.468 347.962 232.041 348.389 232.041 348.915V355.105C232.041 355.368 232.254 355.581 232.517 355.581C232.684 355.581 232.823 355.491 232.908 355.361L232.911 355.362L234.746 353.239C234.822 353.138 234.974 353.138 235.051 353.239L236.885 355.362L236.889 355.361C236.973 355.491 237.112 355.581 237.279 355.581C237.542 355.581 237.755 355.368 237.755 355.105V348.915C237.755 348.389 237.329 347.962 236.803 347.962Z"
                      fill="white"
                    />
                  </g>
                  <rect x="244.898" y="348.772" width="46" height="6" rx="3" fill="#DCDFE4" />
                </g>
              </g>
              <g filter="url(#filter3_d_3169_126761)">
                <g clipPath="url(#clip11_3169_126761)">
                  <rect
                    x="218.232"
                    y="378.201"
                    width="201"
                    height="85.3333"
                    rx="3.33333"
                    fill="white"
                  />
                  <rect x="228.232" y="394.868" width="173" height="6" rx="3" fill="#DCDFE4" />
                  <rect
                    x="228.232"
                    y="412.868"
                    width="44.6667"
                    height="14"
                    rx="2.5"
                    fill="#85B8FF"
                  />
                </g>
              </g>
            </g>
            <rect x="430.232" y="118.535" width="210" height="677" rx="6.66667" fill="#F1F2F4" />
            <rect x="442.066" y="135.535" width="50" height="6" rx="3" fill="#DCDFE4" />
            <g filter="url(#filter4_d_3169_126761)">
              <rect
                x="435.732"
                y="158.535"
                width="199"
                height="85.3333"
                rx="3.33333"
                fill="white"
              />
              <rect x="446.232" y="174.535" width="178" height="6" rx="3" fill="#DCDFE4" />
              <rect x="445.732" y="193.201" width="44.6667" height="14" rx="2" fill="#4BCE97" />
              <g clipPath="url(#clip12_3169_126761)">
                <g clipPath="url(#clip13_3169_126761)">
                  <path
                    d="M457.161 216.772H447.637C446.585 216.772 445.732 217.625 445.732 218.677V228.201C445.732 229.253 446.585 230.105 447.637 230.105H457.161C458.213 230.105 459.066 229.253 459.066 228.201V218.677C459.066 217.625 458.213 216.772 457.161 216.772Z"
                    fill="#63BA3C"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M454.303 219.629H450.493C449.968 219.629 449.541 220.056 449.541 220.582V226.772C449.541 227.035 449.754 227.248 450.017 227.248C450.184 227.248 450.323 227.158 450.408 227.028L450.411 227.029L452.246 224.905C452.322 224.804 452.474 224.804 452.551 224.905L454.385 227.029L454.389 227.028C454.473 227.158 454.612 227.248 454.779 227.248C455.042 227.248 455.255 227.035 455.255 226.772V220.582C455.255 220.056 454.829 219.629 454.303 219.629Z"
                    fill="white"
                  />
                </g>
              </g>
              <rect x="462.615" y="220.201" width="41.9798" height="6" rx="3" fill="#DCDFE4" />
            </g>
            <rect x="218.232" y="94.0347" width="88" height="6" rx="3" fill="#DCDFE4" />
          </g>
        </g>
        <g opacity="0.06">
          <rect x="38" y="34" width="562" height="389" rx="8" fill="#091E42" fillOpacity="0.49" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_d_3169_126761"
          x="27"
          y="23"
          width="583"
          height="411"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.576471 0 0 0 0 0.894118 0 0 0 0 0.866667 0 0 0 0.6 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3169_126761" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3169_126761"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3169_126761"
          x="217.399"
          y="157.701"
          width="202.667"
          height="108"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.416667" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3169_126761" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3169_126761"
            result="shape"
          />
        </filter>
        <filter
          id="filter2_d_3169_126761"
          x="217.399"
          y="270.035"
          width="202.667"
          height="103"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.416667" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3169_126761" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3169_126761"
            result="shape"
          />
        </filter>
        <filter
          id="filter3_d_3169_126761"
          x="217.399"
          y="377.368"
          width="202.667"
          height="86.9999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.416667" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3169_126761" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3169_126761"
            result="shape"
          />
        </filter>
        <filter
          id="filter4_d_3169_126761"
          x="434.899"
          y="157.701"
          width="209.667"
          height="86.9999"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.416667" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3169_126761" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3169_126761"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3169_126761"
          x1="580.416"
          y1="165.401"
          x2="718.6"
          y2="221.496"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#79F2C0" stopOpacity="0" />
          <stop offset="1" stopColor="#4C9AFF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3169_126761"
          x1="271.014"
          y1="118.997"
          x2="393.738"
          y2="-84.9612"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#79F2C0" stopOpacity="0.1" />
          <stop offset="1" stopColor="#4C9AFF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3169_126761"
          x1="268.416"
          y1="120.52"
          x2="380.677"
          y2="385.926"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#79F2C0" stopOpacity="0.1" />
          <stop offset="1" stopColor="#4C9AFF" stopOpacity="0.14" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3169_126761"
          x1="26.416"
          y1="97.4014"
          x2="152.959"
          y2="229.307"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#79F2C0" />
          <stop offset="1" stopColor="#4C9AFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_3169_126761"
          x1="142.509"
          y1="118.527"
          x2="29.879"
          y2="60.9915"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#90E5DA" stopOpacity="0" />
          <stop offset="1" stopColor="#35CEFF" stopOpacity="0.85" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_3169_126761"
          x1="143.183"
          y1="118.226"
          x2="41.9599"
          y2="66.5173"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#90E5DA" stopOpacity="0" />
          <stop offset="1" stopColor="#35CEFF" stopOpacity="0.85" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_3169_126761"
          x1="141.99"
          y1="118.285"
          x2="15.8266"
          y2="53.8363"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#90E5DA" stopOpacity="0" />
          <stop offset="1" stopColor="#35CEFF" stopOpacity="0.85" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_3169_126761"
          x1="20.8718"
          y1="73.5142"
          x2="38.8387"
          y2="73.5142"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#DEEBFF" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_3169_126761"
          x1="4.36216"
          y1="65.6855"
          x2="14.9309"
          y2="67.7268"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#0065FF" />
          <stop offset="1" stopColor="#4C9AFF" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_3169_126761"
          x1="-1.70577"
          y1="74.4723"
          x2="15.9516"
          y2="62.4424"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#0065FF" />
          <stop offset="1" stopColor="#B3D4FF" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_3169_126761"
          x1="555.64"
          y1="445.392"
          x2="474.493"
          y2="370.486"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#5DADF5" stopOpacity="0.57" />
          <stop offset="1" stopColor="#87E9D1" stopOpacity="0.46" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_3169_126761"
          x1="551.254"
          y1="429.454"
          x2="478.628"
          y2="362.413"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#5DADF5" stopOpacity="0.57" />
          <stop offset="1" stopColor="#87E9D1" stopOpacity="0.46" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_3169_126761"
          x1="547.291"
          y1="417.281"
          x2="482.373"
          y2="357.356"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#5DADF5" stopOpacity="0.57" />
          <stop offset="1" stopColor="#87E9D1" stopOpacity="0.46" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_3169_126761"
          x1="543.11"
          y1="404.53"
          x2="486.307"
          y2="352.096"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#5DADF5" stopOpacity="0.57" />
          <stop offset="1" stopColor="#87E9D1" stopOpacity="0.46" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_3169_126761"
          x1="63.2662"
          y1="50.0078"
          x2="60.0668"
          y2="53.36"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.176" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_3169_126761"
          x1="59.6975"
          y1="53.7789"
          x2="55.995"
          y2="57.4392"
          gradientUnits="userSpaceOnUse">
          <stop offset="0.176" stopColor="#0052CC" />
          <stop offset="1" stopColor="#2684FF" />
        </linearGradient>
        <clipPath id="clip0_3169_126761">
          <rect width="630" height="459" fill="white" />
        </clipPath>
        <clipPath id="clip1_3169_126761">
          <rect width="46.6667" height="20" fill="white" transform="translate(51.334 43.7461)" />
        </clipPath>
        <clipPath id="clip2_3169_126761">
          <path
            d="M38 73.4924H198.004V423H46C41.5817 423 38 419.418 38 415V73.4924Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_3169_126761">
          <rect width="160.004" height="303.508" fill="white" transform="translate(38 119.492)" />
        </clipPath>
        <clipPath id="clip4_3169_126761">
          <rect x="44.666" y="203.492" width="146.67" height="32" rx="4" fill="white" />
        </clipPath>
        <clipPath id="clip5_3169_126761">
          <path
            d="M198.004 73.4924H599V415C599 419.418 595.419 423 591 423H198.004V73.4924Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip6_3169_126761">
          <rect x="213.232" y="118.535" width="211" height="677" rx="6.66667" fill="white" />
        </clipPath>
        <clipPath id="clip7_3169_126761">
          <rect
            width="59.6896"
            height="13.3333"
            fill="white"
            transform="translate(228.232 235.201)"
          />
        </clipPath>
        <clipPath id="clip8_3169_126761">
          <rect
            width="13.3333"
            height="13.3333"
            fill="white"
            transform="translate(228.232 235.201)"
          />
        </clipPath>
        <clipPath id="clip9_3169_126761">
          <rect
            width="62.6667"
            height="13.3333"
            fill="white"
            transform="translate(228.232 345.105)"
          />
        </clipPath>
        <clipPath id="clip10_3169_126761">
          <rect
            width="13.3333"
            height="13.3333"
            fill="white"
            transform="translate(228.232 345.105)"
          />
        </clipPath>
        <clipPath id="clip11_3169_126761">
          <rect x="218.232" y="378.201" width="201" height="85.3333" rx="3.33333" fill="white" />
        </clipPath>
        <clipPath id="clip12_3169_126761">
          <rect
            width="13.3333"
            height="13.3333"
            fill="white"
            transform="translate(445.732 216.772)"
          />
        </clipPath>
        <clipPath id="clip13_3169_126761">
          <rect
            width="13.3333"
            height="13.3333"
            fill="white"
            transform="translate(445.732 216.772)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
